import React from 'react'
import { Box, H3 } from '../layout'
import { assetUrl } from '../../utilities'
import { Bullets } from '../pricing'
import { Link } from 'gatsby'
import './BuiltOnResearch.css'

export const BuiltOnResearch = () => (
  <Box className="built-on-research section-padding">
    <Box className="section" justifyContent="center">
      <img src={assetUrl('phd.png')} alt="phd" style={{ objectFit: 'contain' }}/>
    </Box>
    <Box className="section" column gap={40} justifyContent="center">
      <H3 align="left">Built on Research, proven in practice.</H3>
      <Bullets
        tickColor="white"
        backgroundColor="blue"
        items={['PhD-based framework', 'Used by teams at all levels across the world']}
      />
      <Box gap={16}>
        <Link to="/foundations" className="button-anchor">Learn more</Link>
        <button onClick={() => window.open('https://www.proquest.com/openview/97bd314fa7405bb659525d27909c828d/1?pq-origsite=gscholar&cbl=2026366&diss=y', '_blank')}>Download PhD</button>
      </Box>
    </Box>
  </Box>
)